/**
 * @generated SignedSource<<d0977259eff948d3289294d83ee20e7c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FocusFrameQuery$variables = {
  storecastId: string;
};
export type FocusFrameQuery$data = {
  readonly dashboard: {
    readonly focusedNodeId: string | null;
    readonly id: string;
  } | null;
};
export type FocusFrameQuery = {
  response: FocusFrameQuery$data;
  variables: FocusFrameQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storecastId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "Dashboard",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "focusedNodeId",
            "storageKey": null
          }
        ]
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FocusFrameQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FocusFrameQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "aaa4ca1e9e212cb513dfe9a22f552bbb",
    "id": null,
    "metadata": {},
    "name": "FocusFrameQuery",
    "operationKind": "query",
    "text": "query FocusFrameQuery(\n  $storecastId: ID!\n) {\n  dashboard(id: $storecastId) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "aaa4161a41368295b27b22fcff3c01af";

export default node;
